module.exports = __webpack_public_path__ + "img/coronavirus.337960f5.png";